"use client";
import { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { addMedicationOption } from "../../../../services/admin/medicationOptions";
import toast from "react-hot-toast";

import styles from "./medicationOptions.module.css";
import { useParams } from "react-router-dom";
import Button from "../../../../components/button-v1";
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../../../components/ui/dialog";
const AddMedicationOptionModal = ({ isOpen, onClose }) => {
  const { id: location_id } = useParams();
  const queryClient = useQueryClient();

  const [medicationName, setMedicationName] = useState("");
  const [strength, setStrength] = useState("");
  const [directions, setDirections] = useState("");

  const data = {
    name: medicationName,
    strength: strength,
    directions: directions,
  };

  const mutation = useMutation(() => addMedicationOption(data, location_id), {
    onSuccess: () => {
      toast.success("Medication Option added successfully");
      queryClient.invalidateQueries(["medicationOptions"]);
      onClose();
    },
    onError: (error) => {
      toast.error(error.response?.data?.message || "Could not add medication.");
    },
  });

  const handleSave = () => {
    if (medicationName && strength && directions) {
      mutation.mutate();
    } else {
      toast.error("Please fill all fields");
    }
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <Dialog open={isOpen} setOpen={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Add Medication Options</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <form onSubmit={handleSave}>
            <div
              className={`${styles.comp_wrapper} ${
                mutation.isLoading ? styles.loading : ""
              }`}
            >
              <div className={styles.input_group}>
                <div className={styles.input_field}>
                  <label htmlFor="name">Medicine Name</label>
                  <input
                    type="text"
                    id="name"
                    value={medicationName}
                    onChange={(e) => setMedicationName(e.target.value)}
                    required
                  />
                </div>
              </div>

              <div className={styles.input_group}>
                <div className={styles.input_field}>
                  <label htmlFor="strength">Strength</label>
                  <input
                    type="text"
                    id="strength"
                    value={strength}
                    onChange={(e) => setStrength(e.target.value)}
                    required
                  />
                </div>
              </div>

              <div className={styles.input_group}>
                <div className={styles.input_field}>
                  <label htmlFor="directions">Directions</label>
                  <textarea
                    id="directions"
                    value={directions}
                    onChange={(e) => setDirections(e.target.value)}
                    required
                    rows={3}
                  />
                </div>
              </div>
            </div>
          </form>
        </DialogBody>
        <DialogFooter>
          <Button variant="ghost" onClick={onClose}>
            Close
          </Button>
          <Button
            type="submit"
            disabled={mutation.isLoading}
            loading={mutation.isLoading}
            onClick={() => handleSave()}
          >
            {mutation.isLoading ? "Adding..." : "Add"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default AddMedicationOptionModal;
